import React, { forwardRef, useMemo } from "react";

const useCreateLinkComponent = (Component) => {
  return useMemo(
    () =>
      forwardRef(({ navigate, ...props }, ref) => {
        const handleClick = (e) => {
          e.preventDefault();
          navigate(e);
        };

        return (
          <Component ref={ref} {...props} onClick={handleClick}>
            {props.children}
          </Component>
        );
      }),
    []
  );
};

export default useCreateLinkComponent;
